<template>
<div>
  <div id="main-content" class="container">
    <div class="oc-participant-area oci-white" >

      <div id="oc-chatters" class="" >
        <div id="chatters-heading"><span>Active Client Chats</span>
          <span @click="handleCloseChat" class="oc-close-chat">Close X</span>
        </div>
        <div class="oc-participant-container ">
          <div class="oc-participant-wrapper" >
            <div v-for="item in purchaserChats" :key="item.chatId">
              <div v-on:click="handleChatSelected(item)" class="oc-chat-participant" >
                <div>
                  <i class="fa fa-user-circle  "></i>&nbsp;
                  <span>{{item.purchaserName}}</span>
                  <span class="oc-chat-participant-detail ">{{item.lastMessageSendTime}} <!--{{$ociUtils.messaging.formatChatTime(new Date(item.lastReceivedFromEpoch))}} --> </span>
                </div>
                <div class="oc-last-message"> {{item.lastMessage}}<!--{{item.messages[item.messages.length-1].content}} --></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="oc-chat-area" v-if="showChat">

        <!-- Conversation Box  -->
        <div id="oc-conversation" class="" >
          <div id="oc-conversation-heading" >
            <i class="fa fa-user-circle fa-2x" ></i>&nbsp;&nbsp;
            <span class="oc-chat-participant-heading">{{chatHeading}}</span>
          </div>
          <div class="oc-chat-message-container">
            <div class="oc-chat-wrapper " ref="chatWrapper" v-slimscroll="scrollOptions">
              <div v-for="item in currentOrderedMessages" :key="item.createdFromEpoch" >
                <chat-message v-bind:item="item" v-bind:sender="appUser.profileId"></chat-message>
              </div>
            </div>
          </div>
        </div>
        <!-- Message Box  -->
        <div id="message-type-area" class="oc-message-area">
          <input type="text"
                 id="oc-message-input-box" class="col-md-8 oc-message-input"
                 v-model="chatMessage.content"  v-on:keyup="handleMessageKeyUp"
                 placeholder="Type your message...">
          <button id="send" class="btn btn-primary oci-white-background ml-2" type="submit" @click.prevent="send">Send</button>
        </div>

      </div>
    </div>

  </div>
</div>
</template>

<script>

  import Auth from  '@/common/components/auth/Auth.vue';
  import {Form,FormItem,Button, Table, TableColumn,Dropdown, DropdownItem, DropdownMenu, Card} from 'element-ui';
  import ChatMessage from '@/common/components/chat/ChatMessage.vue';
    export default {
      name: "BrokerMiniChat",
      components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Form.name]: Form,
        [Button.name]: Button,
        [FormItem.name]: FormItem,
        [Card.name]: Card,
        Auth,
        ChatMessage,
      },

      data() {
        return {
          scrollOptions: {
            height: '100%',
            size: '10px',
            color: '#d3d3d3'
          },
          showChat:false,
          count:0,
          received_messages: [],
          send_message: null,
          connected: false,
          chats:[],
          chatHeading:'Select a Client',
          userMessage:false,
          chatMessages:[],
          currentChatMessages:[],
          allChatMessages:[],
          currentChat:{},
          purchaserChat:{
            chatId:0,
            chatRefId:0,
            initiated:0,
            createdFromEpoch:0,
            chatType:'',
            lastMessage:'',
            lastMessageSendTime:'',
            purchaserName:'',
            messages:[],

          },
          chatRefId:0,
          currentChatRefId:0,

          chatMessage:{
            chat:{
              chatId:0,
              chatRefId:0,
              initiated:0,
              createdFromEpoch:0,
              chatType:'',
              lastMessage:'',
              lastMessageSendTime:'',
              purchaserName:'',
              lastReceivedFromEpoch:'',
              messages:[]
            },
            chatMessageId:0,
            sentTime: '',
            deliveredTime: '',
            viewedTime: '',
            senderName: '',
            sender: 0,
            createdFromEpoch: 0,
            brokeredFromEpoch: 0,
            content: ''
          },
        }

      },
      computed: {
        appUser: {
          get() {
            return this.$store.getters.appUser;
          }
        },
        purchaserChats: {
          get() {
            return this.$store.getters.purchaserChats
          },
        },
        currentOrderedMessages: {
          get() {
            this.$ociUtils.messaging.orderMessagesByCreatedFromEpoch(this.currentChatMessages)
            return this.currentChatMessages
          }
        },
      },
      methods:{
        //Ordering of chat clients


        orderByLastReceived(chats){
          chats.sort(function(a,b) {
              let comparison= 0;
            let aUpdate = a.lastReceivedFromEpoch
            let bUpdate = b.lastReceivedFromEpoch
              if (aUpdate>bUpdate){
                comparison = 1;
              }
              else if (aUpdate<bUpdate){
                comparison = -1;
              }
              this.ociLog("sort called")
              return comparison*-1;
            }
          )
        },

        //TODO - not used ordering to show at top clients who have been waiting on a response the longest
        //ordering to show at top clients who have been waiting on a response the longest
        orderByReceivedSentDifference(chats){
          chats.sort(function(a,b) {
              let comparison= 0;
              let aUpdate = a.lastReceivedFromEpoch-a.lastSentFromEpoch
              let bUpdate = b.lastReceivedFromEpoch-b.lastSentFromEpoch
              if (aUpdate>bUpdate){
                comparison = 1;
              }
              else if (aUpdate<bUpdate){
                comparison = -1;
              }
              this.ociLog("sort called")
              return comparison*-1;
            }
          )
        },

        // event handlers

        handleChatSelected(chat){
          this.ociLog("Chat selected ");

          this.currentChatMessages = chat.messages;
          this.currentChat = chat;
          this.currentChatRefId=chat.chatRefId
          // this.ociLog(this.currentChatMessages);
          this.ociLog(chat);
          //this.chatHeading=chat.username;
          this.showChat=true;
          this.$nextTick(() => {
            this.ociLog("next tick")
            let chatWrapper = this.$refs.chatWrapper;
            chatWrapper.scrollTop=chatWrapper.scrollHeight;
          })
        },
        handleMessageKeyUp(e){
          this.ociLog(e.keyCode)
          if(e.keyCode===13){this.send()}
        },
        handleCloseChat(){
          this.$parent.handleCloseChat();
          this.ociLog("Closed Chat")

        },
        //load Purchaser Chats
        loadPurchaserChats(){
          this.$store.dispatch('loadPurchaserChats').then(this.ociLog("loadPurchaserChats method called"));
        },
        //load currently selected chat messages
        loadCurentChatMessages(chatId){
          this.$store.dispatch('loadCurrentChatMessages',chatId).then(this.ociLog("loadCurentChatMessages method called"));
        },
        loadRecentPurchaserChats(days){
          this.$store.dispatch('loadRecentPurchaserChats',days).then(this.ociLog("loadCurentChatMessages method called"));
        },

        // Sockets and Stomp methods

        send() {
          this.ociLog("Send message:" + this.send_message);
          if (this.stompClient && this.stompClient.connected) {
            //TO-DO add validation check if no received chat message from purchaser

            let sendTime = new Date();

            // first create new copy of chatMessage, since assignment would be to same object in memory
            let sendMsg = JSON.parse(JSON.stringify(this.chatMessage));
            sendMsg.chat.chatId = this.currentChat.chatId;
            sendMsg.chat.chatRefId=this.currentChatRefId;
            sendMsg.chat.initiated=this.currentChat.initiated;
            sendMsg.chat.chatType="purchaser-broker";
            sendMsg.chat.createdFromEpoch=this.currentChat.createdFromEpoch;
            sendMsg.sender= this.$store.getters.appUser.profileId;
            sendMsg.senderName=this.$store.getters.appUser.firstName +" "+this.$store.getters.appUser.lastName;
            sendMsg.sentTime=this.$ociUtils.messaging.formatChatTime(sendTime);
            sendMsg.createdFromEpoch = Math.floor(sendTime.getTime()/1000);
            // there should be a chat already, since broker only responds to existing message,
            // do a check and add this to sent message to correct chat's messages.

            for (let i=0; i<this.$store.getters.purchaserChats.length;i++){
              if(this.$store.getters.purchaserChats[i].chatRefId === sendMsg.chat.chatRefId){
                // this.chats[i].messages.push(sendMsg) No need to push message locally, cause it goes to both destinations
                this.$store.getters.purchaserChats[i].lastSentFromEpoch=sendTime.getTime();
                this.stompClient.send(this.$ociSockets.BROKER_CHAT_OUTBOX+'/'+this.$store.getters.purchaserChats[i].chatRefId, JSON.stringify(sendMsg), {});
                break;
              }
            }
            //TODO fix ordering from getter instead
            this.orderByLastReceived(this.$store.getters.purchaserChats);
            this.chatMessage.content='';
            this.$nextTick(() => {
              this.ociLog("next tick")
              let chatWrapper = this.$refs.chatWrapper;
              chatWrapper.scrollTop=chatWrapper.scrollHeight;

            })
          }
        },
        connect() {
          //URL for backend stomp broker
          this.socket = new this.$ociSockets.SockJS(this.$ociSockets.SOCKET_ENDPOINT_BASE);
          this.stompClient = this.$ociSockets.Stomp.over(this.socket);
          this.stompClient.connect(
            {},
            frame => {
              this.connected = true;
              this.ociLog(frame);
              this.stompClient.subscribe(this.$ociSockets.BROKER_CHAT_INBOX, tick => {

                let newChat = JSON.parse(JSON.stringify(this.purchaserChat));
                let receivedMessage= JSON.parse(tick.body);
                let receivedTime = new Date();
                receivedMessage.receivedTime=this.$ociUtils.messaging.formatChatTime(receivedTime);
                let chatExists = false;

                this.ociLog("Chats length is different !==  0--- ")


                // do check if chat exists with same chatRefId
                for (let i = 0; i < this.$store.getters.purchaserChats.length; i++) {
                  this.ociLog("Chats loop--- ")
                  this.ociLog("ChatId in receivedMessage -- " + receivedMessage.chat.chatRefId)
                  this.ociLog("ChatId in this.chats[i] -- " + this.$store.getters.purchaserChats[i].chatRefId)
                  if (this.$store.getters.purchaserChats[i].chatRefId === receivedMessage.chat.chatRefId) {
                    this.ociLog("ChatsId match chatId in message--- ")
                    this.ociLog(this.$store.getters.purchaserChats[i].messages)
                    this.$store.getters.purchaserChats[i].messages.push(receivedMessage)
                    this.$store.getters.purchaserChats[i].lastReceivedFromEpoch = receivedTime.getTime()
                    chatExists = true;
                    break;
                  }
                }

                //if there is no match with the then create a new one
                if (chatExists === false) {
                  this.ociLog("This creating a new chat because of no match--- ")
                  // //newChat.username=receivedMessage.username;
                  // newChat.chatId=receivedMessage.chat.chatId;
                  // newChat.chatRefId = receivedMessage.chat.chatRefId;
                  // newChat.initiated = receivedMessage.chat.initiated;
                  // newChat.lastReceivedMessage=;
                  // newChat.lastReceivedFromEpoch = receivedMessage.chat.lastReceivedFromEpoch
                  // newChat.createdFromEpoch =receivedMessage.chat.createdFromEpoch
                  // newChat.lastMessageSendTime = receivedMessage.chat.lastMessageSendTime
                  // newChat.purchaserName = receivedMessage.senderName;
                  //
                  // newChat.lastReceivedFromEpoch = receivedTime.getTime();
                  // //add the message to this chat
                  // newChat.messages = [receivedMessage];
                  //add chat to the chats array
                  //this.chats.push(newChat);
                  // Add Chat to global store
                  // if (this.$store.getters.purchaserChats.length<1){
                  //   this.ociLog("inside Received -- Purchase Chats<1 -----")
                  //   let chats = []
                  //   chats.push(newChat)
                  //   //this.$store.getters.purchaserChats=chats;
                  //   this.$store.dispatch("addPurchaserChatFromLocal",chats).then();
                  // }
                  // else {
                  //   this.$store.getters.purchaserChats.push(newChat)
                  // }

                  let newChat = JSON.parse(JSON.stringify(receivedMessage.chat));
                  newChat.messages = [receivedMessage]
                  this.$store.dispatch("addPurchaserChatFromLocal",receivedMessage.chat).then();



                }


                this.orderByLastReceived(this.$store.getters.purchaserChats);
                this.$nextTick(() => {
                  this.ociLog("next tick")
                  let chatWrapper = this.$refs.chatWrapper;
                  chatWrapper.scrollTop=chatWrapper.scrollHeight;
                })


              });
            },
            error => {
              this.ociLog(error);
              this.connected = false;
            }
          );
        },
        disconnect() {
          if (this.stompClient) {
            this.stompClient.disconnect();
          }
          this.connected = false;
        },
        tickleConnection() {
          this.connected ? this.disconnect() : this.connect();
        },

        // Sockets and Stomp methods  -- End





      },
      mounted(){
      this.connect();
        this.loadRecentPurchaserChats(10);
      },
      beforeDestroy(){
        this.disconnect();
      }
    }
</script>

<style scoped>
  #main-content{
  }
  #oc-chatters{
    background-color: whitesmoke;
    border-radius: 3px;
    border: 1px #007dc2 solid;
    margin:8px;
    padding:8px;
  }

  .oc-chat-area {
    border-radius: 3px;
    border:1px #007dc2 solid;
    padding:13px;
    /*margin-top:0;*/
    /*border-radius: 10px 10px 10px 10px;*/
    background-color:  whitesmoke;
  }
  #oc-conversation-heading{
    padding:10px 0px 16px;
    font-size: 1em;
    color:#007dc2;
  }
  .oc-chat-participant-heading{
  }
  .oc-chat-message-container, oc-participant-container{
    min-height: 200px;
    border-radius: 3px;
    border: 1px #dfdfdf solid;
    background-color: white;
    padding: 4px;
  }
  .oc-chat-wrapper{
  }
  .oc-chat-participant{
    padding:4px;
    margin-bottom: 2px;
    margin-top: 4px;
    border-radius: 3px;
    color: whitesmoke;
    border-bottom: 1px solid #bebebe;
    background-color: #999999;
  }
  .oc-chat-participant:hover{
    background-color: #cecece;
    color: #3f3f3f;
    cursor:pointer;
  }
  .oc-message-area{
    margin: auto;
    text-align:center;
  }
  .oc-message-input{
    padding:8px;
    border-radius: 3px;
    border: 1px #dfdfdf solid;
  }
  .co-chat-send{
  }

  .oc-participant-area{
    margin-bottom: 2px;
    width: auto;
  }
  #oc-conversation{
  }

  .oc-chat-participant-detail{
    font-size: .8em;
    float:right;
  }
  .oc-last-message{

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  #chatters-heading{
    padding-bottom: 10px;
    font-size: 1em;
    color: #007dc2;
    border-bottom: 1px solid #007dc2;
  }
  .oc-close-chat{
    float:right;
    cursor:pointer;
    font-size: .8em;
  }

</style>
